/**
 * Quizz Presentational Component
 * View: Displays an episode Quizz
 */

import React from 'react';

class RiskAndSensationAnswer extends React.Component {
  render() {
    return <div className="answer">
      <div className="container" style={{ backgroundImage: `url('${this.props.background}')` }}>
        {this.createAnswerPage()}
      </div>
    </div>
  }

  createAnswerPage() {
    return <img src={this.props.title} alt="this.props.title"></img>
  }
}


RiskAndSensationAnswer.propTypes = {
  background: React.PropTypes.string,
  title: React.PropTypes.string,
};

RiskAndSensationAnswer.defaultProps = {
  background: "null",
  title: "Si l'on rencontre un ours agressif pendant une randonnée, vaut-il mieux se trouver sur un cheval?",
};


export default RiskAndSensationAnswer;



// WEBPACK FOOTER //
// ./src/components/riskAndSensation/RiskAndSensationAnswer.js